import { IHealthLineItemDetail } from '../interfaces/IHealthLineItemDetail.interface';

export class HealthLineItemDetail implements IHealthLineItemDetail {
	Id: number;
	DetailLineItemId: number;
    IncidentType: number;
    IncidentResultNotes: string;
    Medication: string;
    MedicationDose: string;
    AdditionalNotes: string;
}


// WEBPACK FOOTER //
// ./src/app/models/HealthLineItemDetail.ts